module.exports = __webpack_public_path__ + "static/media/onza_thumb_even.d4a150d5.webp";